import _ from 'lodash';

/**
 * Based on the autocomplete situation of a field, determine which icon and message to show to the user
 * @param fieldName The name of the field in the form
 * @param autocompleteContext The autocomplete context
 * @returns {{color: string, icon: string, tooltip: string}} | null
 */
export function fieldStatusIcon(autocompleteContext, fieldName) {
    if (_.get(autocompleteContext, `loading[${fieldName}]`) > 0) {
        return {icon: 'HourglassEmpty', color: 'var(--primary)', tooltip: 'Data wordt geladen...'};
    }
    if (_.get(autocompleteContext, `statuses[${fieldName}]`) === 'success') {
        return {
            icon: 'CheckCircle',
            color: 'var(--success)',
            tooltip: _.get(autocompleteContext, `messages[${fieldName}]`, ''),
        };
    }
    if (_.get(autocompleteContext, `statuses[${fieldName}]`) === 'warning') {
        return {
            icon: 'Warning',
            color: 'var(--warning)',
            tooltip: _.get(autocompleteContext, `messages[${fieldName}]`, ''),
        };
    }
    if (_.get(autocompleteContext, `statuses[${fieldName}]`) === 'error') {
        return {
            icon: 'Error',
            color: 'var(--danger)',
            tooltip: _.get(autocompleteContext, `messages[${fieldName}]`, ''),
        };
    }
    return null;
}
